import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class SupplierService extends Service {
	constructor(injector: Injector) {
		super("Supplier", injector);
	}
}